// src/utils/accountAdditionalEmailsUtils.js
// Shared parsing for wholesale account "additional" notification emails (Account Settings).

/** @returns {string} */
function cleanEmailLocal(v) {
    return String(v || '').trim();
}

/**
 * Rows from `users` profile: `additional_email_1`, …, and optional `additionalEmails` array.
 * @returns {{ email: string, firstName: string, lastName: string }[]}
 */
export function extractAdditionalEmailRowsFromUserProfileData(data) {
    if (!data || typeof data !== 'object') return [];
    const out = [];
    const seen = new Set();

    const pushRow = (row) => {
        if (!row || typeof row !== 'object') return;
        const em = cleanEmailLocal(row.email);
        if (!em) return;
        const key = em.toLowerCase();
        if (seen.has(key)) return;
        seen.add(key);
        out.push({
            email: em.toLowerCase(),
            firstName: String(row.firstName || '').trim(),
            lastName: String(row.lastName || '').trim(),
            notifyOrders: row.notifyOrders !== false,
            notifyInvoices: row.notifyInvoices !== false,
        });
    };

    if (Array.isArray(data.additionalEmails)) {
        for (const row of data.additionalEmails) pushRow(row);
    }
    for (const k of Object.keys(data)) {
        if (!k.startsWith('additional_email_')) continue;
        pushRow(data[k]);
    }
    return out;
}
